import React, { useState, useEffect } from 'react';
import { Formik } from 'formik';
import { useSelector } from 'react-redux';
import InsertCommentIcon from '@material-ui/icons/InsertComment';
import Typography from '@material-ui/core/Typography';
// import Select from '@material-ui/core/Select';
// import Box from '@material-ui/core/Box';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import PreviewImage from '../../../assets/previewImage.png';
import Tooltip from '@material-ui/core/Tooltip';
import PreviewModal from '../../../components/modal/previewModal';
import LoaderPopUp from '../../../components/loaderpopup/loader';
import { CommonConfig } from '../../../config/common-config';
import downloadImage from '../../../assets/downloadImage.png';
import axios from 'axios';
import buttonDisable from '../../disableField/buttonDisable';
import { userType } from '../../../config/usertypeValue';
import './styles.css';

const CRCCapitalgain = (props) => {
    //const { handleRelevence, classes, apiResponse } = props;
    const { handleRelevence, classes, StyledRadio, apiResponse } = props;
    const [checklist, setChecklist] = React.useState('');
    const checklistValues = checklist.checklistJson;
    const checklist1 = checklistValues && checklistValues.checklistL1;
    const checklist1que = checklist1 && checklist1.questions;

    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    // const serviceIdValue = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const stageId = useSelector((state) => state.serviceCheckListReducer.selectedStageId);
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.features[0].branchName;
    const [visible, setVisible] = React.useState(false);
    const [downloadFile, setDownloadFile] = useState('');
    const [showBtnLoader, setShowBtnLoader] = useState(false);

    //console.log("checklist1que:",checklist1que);
    useEffect(() => {
        setChecklist(props.apiResponse);
        //console.log('useEffect capitalGain apiResponse crc', props.apiResponse);
        setTimeout(() => {
            userType.capitalInitializeFlag = false;
        }, 800);
    }, [props, userToken]);

    let initialValues = {};

    if (checklist1que && checklist1que[2].subQuestion[3].fields.length > 0) {
        initialValues.capitalGain = checklist1que[2].subQuestion[3].fields;
    } else {
        let capitalGainArr = [];
        let capitalGain = {
            fieldName: '',
            relevanceRemarksAM: '',
            relevanceRemarksCRC: '',
            relevanceResponseAM: '',
            relevanceResponseCRC: '',
        };
        capitalGainArr.push(capitalGain);
        initialValues.capitalGain = capitalGainArr;
    }

    const agricultureArr = [];
    if (checklist1que && checklist1que[2].subQuestion[5].fields.length > 1) {
        //console.log('Field Length', checklist1que[4].fields.length);
        for (let i = 0; i < checklist1que[2].subQuestion[5].fields.length; i += 6) {
            const agricultureArrtemp = {
                agricultureName: (checklist1que && checklist1que[2].subQuestion[5].fields[i].response) || '',
                agricultureNameCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[5].fields[i].relevanceResponseCRC,
                agricultureNameCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[5].fields[i].relevanceRemarksCRC,
                agriAmount: (checklist1que && checklist1que[2].subQuestion[5].fields[i + 1].response) || '',
                agriAmountCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[5].fields[i + 1].relevanceResponseCRC,
                agriAmountCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[5].fields[i + 1].relevanceRemarksCRC,
                agriReceipt: (checklist1que && checklist1que[2].subQuestion[5].fields[i + 2].response) || '',
                agriReceiptCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[5].fields[i + 2].relevanceResponseCRC,
                agriReceiptCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[5].fields[i + 2].relevanceRemarksCRC,
                agriExpenses: (checklist1que && checklist1que[2].subQuestion[5].fields[i + 3].response) || '',
                agriExpensesCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[5].fields[i + 3].relevanceResponseCRC,
                agriExpensesCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[5].fields[i + 3].relevanceRemarksCRC,
                agriReceiptUpload: (checklist1que && checklist1que[2].subQuestion[5].fields[i + 4].response) || '',
                agriExpensesUpload: (checklist1que && checklist1que[2].subQuestion[5].fields[i + 5].response) || '',
            };
            agricultureArr.push(agricultureArrtemp);
        }
    } else {
        const agricultureArrtemp = {
            agricultureName: '',
            agriAmount: '',
            agriReceipt: '',
            agriExpenses: '',
            agriReceiptUpload: '',
            agriExpensesUpload: '',
        };
        agricultureArr.push(agricultureArrtemp);
    }
    initialValues.agriculture = agricultureArr;

    initialValues.soldAnyAsset = (checklist1que && checklist1que[2].subQuestion[3].response) || 'Yes';
    //console.log("initialValues.capitalGain:",initialValues.capitalGain);

    const handleModalClose = () => {
        setVisible(false);
    };

    const handlePreviewModal = (file) => {
        setDownloadFile(`${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${file}`);
        setShowBtnLoader(true);
        setTimeout(() => {
            setShowBtnLoader(false);
            setVisible(true);
        }, 1000);
    };

    const downloadCoreFile = (file) => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${file}`, {
                // method: 'GET',
                headers: {
                    Authorization: bearerToken,
                },
                responseType: 'blob',
            })

            .then((response) => {
                const link = document.createElement('a');
                link.href = response.config.url;
                link.setAttribute('download', response.config.url);
                link.click();
            });
    };

    return (
        <Formik initialValues={initialValues} enableReinitialize={userType.capitalInitializeFlag}>
            {(formik) => {
                //console.log("CapitalGainFormIKValues:",formik)
                return (
                    <Grid container spacing={3} className="main-container w100i">
                        <Grid item xs={12} sm={12}>
                            <FormControl fullWidth className={classes.margin}>
                                <Typography variant="subtitle1" gutterBottom>
                                    Have you sold any assets this year?
                                </Typography>
                            </FormControl>
                            <FormControl component="fieldset">
                                <RadioGroup
                                    defaultValue="Yes"
                                    className="radio-option mb15"
                                    name="soldAnyAsset"
                                    value={formik.values.soldAnyAsset}
                                >
                                    <ul className={classes.inlineDisplay}>
                                        <li>
                                            <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                        </li>
                                        <li>
                                            <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                        </li>
                                    </ul>
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        {formik.values.soldAnyAsset === 'Yes' ? (
                            <span style={{ width: '100%' }}>
                                <Grid item xs={12} sm={12} style={{ display: 'flex' }}>
                                    <Typography variant="subtitle1" gutterBottom>
                                        Choose the nature of assets, which are sold during the year?
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} style={{ width: '100%' }}>
                                    {formik.values.capitalGain.map((capitalGainItem, capitalGainIndex) => {
                                        return (
                                            <FormControl fullWidth className={classes.margin}>
                                                <Grid item xs={12} sm={12} style={{ paddingLeft: '0px', display: 'flex', width: '100%' }}>
                                                    <div style={{ width: '100%' }}>
                                                        {formik.values.capitalGain[capitalGainIndex].fieldName === 'natureAssets' ? (
                                                            <Grid item xs={12} sm={12} style={{ paddingLeft: '0px' }}>
                                                                <FormControl fullWidth className={classes.margin}>
                                                                    <InputLabel htmlFor="enter-the-nature" style={{ marginTop: '6px' }}>
                                                                        Select the Nature
                                                                    </InputLabel>
                                                                    <Input
                                                                        disabled
                                                                        className={classes.bottomLine}
                                                                        id="enter-the-nature"
                                                                        placeholder="Nature Assets"
                                                                        value={capitalGainItem.response}
                                                                    />
                                                                    {/* <Select
                                                                        disabled
                                                                        native
                                                                        className={classes.selectView}
                                                                        placeholder="Nature Assets"
                                                                        value={capitalGainItem.response}
                                                                    >
                                                                        <option value="">Select Nature Type</option>
                                                                        <option value="Loan">Loan</option>
                                                                        <option value="Building">Building</option>
                                                                        <option value="Residential house">Residential house</option>
                                                                        <option value="Shares">Shares</option>
                                                                        <option value="Mutual funds">Mutual funds</option>
                                                                        <option value="Future and Options(F & O)">
                                                                            Future and Options(F & O)
                                                                        </option>
                                                                        <option value="Personal Jewellary">Personal Jewellary</option>
                                                                        <option value="Others">Others</option>
                                                                    </Select> */}

                                                                    {/* <Input
                                                                        disabled
                                                                        className={classes.bottomLine}
                                                                        id="standard-adornment-amount"
                                                                        value={capitalGainItem.response}
                                                                        // onChange={handleChange('pan')}
                                                                    /> */}
                                                                    {/* <div className={classes.btnFieldPositionRight}></div> */}
                                                                    {/* {capitalGainItem.relevanceResponseCRC && (
                                                                        
                                                                        */}

                                                                    {checklist1que && checklist1que[2].subQuestion[3].fields &&
                                                                        checklist1que && checklist1que[2].subQuestion[3].fields[capitalGainIndex] ? (
                                                                            checklist1que && checklist1que[2].subQuestion[3].fields[capitalGainIndex].relevanceResponseCRC ===
                                                                                'Relevant' ? (
                                                                                    <div className={classes.relevanceIndicator}>
                                                                                        {
                                                                                            checklist1que && checklist1que[2].subQuestion[3].fields[capitalGainIndex]
                                                                                                .relevanceRemarksCRC
                                                                                        }
                                                                                    </div>
                                                                                ) : checklist1que && checklist1que[2].subQuestion[3].fields[capitalGainIndex].relevanceResponseCRC ===
                                                                                    'Irrelavant' ? (
                                                                                        <div className={classes.irrelevanceIndicator}>
                                                                                            {
                                                                                                checklist1que && checklist1que[2].subQuestion[3].fields[capitalGainIndex]
                                                                                                    .relevanceRemarksCRC
                                                                                            }
                                                                                        </div>
                                                                                    ) : checklist1que && checklist1que[2].subQuestion[3].fields[capitalGainIndex].relevanceResponseCRC ===
                                                                                        'Paritially Relevant' ? (
                                                                                            <div className={classes.partrelevanceIndicator}>
                                                                                                {
                                                                                                    checklist1que && checklist1que[2].subQuestion[3].fields[capitalGainIndex]
                                                                                                        .relevanceRemarksCRC
                                                                                                }
                                                                                            </div>
                                                                                        ) : (
                                                                                            ''
                                                                                        )
                                                                        ) :
                                                                        < div >
                                                                            <Typography className={classes.bottomLine}>
                                                                                {capitalGainItem.relevanceResponseCRC === 'Relevant' ? (
                                                                                    <div className={classes.relevanceIndicator}>
                                                                                        {capitalGainItem.relevanceRemarksCRC}{' '}
                                                                                    </div>
                                                                                ) : capitalGainItem.relevanceResponseCRC ===
                                                                                    'Irrelavant' ? (
                                                                                            <div className={classes.irrelevanceIndicator}>
                                                                                                {capitalGainItem.relevanceRemarksCRC}
                                                                                            </div>
                                                                                        ) : capitalGainItem.relevanceResponseCRC ===
                                                                                            'Paritially Relevant' ? (
                                                                                                <div className={classes.partrelevanceIndicator}>
                                                                                                    {capitalGainItem.relevanceRemarksCRC}
                                                                                                </div>
                                                                                            ) : (
                                                                                                ''
                                                                                            )}
                                                                            </Typography>
                                                                        </div>
                                                                    }
                                                                    {stageId === 10 && usertype === 'EM' ? (
                                                                        ''
                                                                    ) : stageId === 8 &&
                                                                        capitalGainItem.relevanceResponseCRC === 'Relevant' ? (
                                                                                ''
                                                                            ) : (
                                                                                // {stageId === 10 && usertype === 'EM' ? ('') : (
                                                                                <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    size="small"
                                                                                    className={classes.button}
                                                                                    startIcon={<InsertCommentIcon />}
                                                                                    onClick={() =>
                                                                                        handleRelevence(
                                                                                            'capitalGain',
                                                                                            'capitalGain',
                                                                                            capitalGainIndex,
                                                                                            'natureAssests',
                                                                                            capitalGainItem
                                                                                        )
                                                                                    }
                                                                                    disabled={buttonDisable(stageId, userType.value)}
                                                                                >
                                                                                    Add Relevance
                                                                        </Button>
                                                                            )}
                                                                </FormControl>
                                                            </Grid>
                                                        ) : null}
                                                        {formik.values.capitalGain[capitalGainIndex].fieldName === 'natureAssetsUpload' ? (
                                                            // <ul className={classes.inlineDisplay}>
                                                            //     <li>
                                                            //         <div>
                                                            //             {/* <Button type="submit" className={classes.chekListAddBtn} title="Add Bank" /> */}
                                                            //             <Button variant="outlined" color="primary" className="txt-capitalize">
                                                            //                 Add Attachment if any
                                                            //             </Button>
                                                            //         </div>
                                                            //     </li>
                                                            // <li>
                                                            // <Grid item xs={6} sm={6} style={{ marginTop: '10px' }}>
                                                            <div
                                                                className="lft-40"
                                                                style={{
                                                                    marginRight: '7px',
                                                                    position: 'absolute',
                                                                    right: '0',
                                                                    top: '-100px',
                                                                    color: '#000000',
                                                                }}
                                                            >
                                                                {capitalGainItem && capitalGainItem.response ? ( //houseList.some(function (el) { return el.fieldName === 'loanUpload' }) ?
                                                                    // <span style={{ marginRight: '7px', marginLeft: '12px', color: '#000000' }}>{capitalGainItem.response.split(/-(.+)/)[1].substring(0, 15)}
                                                                    // {capitalGainItem.response.split(/-(.+)/)[1].length > 15 ? '...' : ''}</span> : null}
                                                                    <span
                                                                        style={{
                                                                            marginRight: '7px',
                                                                            // position: 'absolute',
                                                                            // left: '-110px',
                                                                            // top: '10px',
                                                                            color: '#000000',
                                                                        }}
                                                                        className="txtFontSmall"
                                                                    >
                                                                        {capitalGainItem.response
                                                                            .substring(capitalGainItem.response.lastIndexOf('/') + 1)
                                                                            .substring(0, 15)}
                                                                        {capitalGainItem.response
                                                                            .substring(capitalGainItem.response.lastIndexOf('/') + 1)
                                                                            .substring(0, 15).length > 15
                                                                            ? '...'
                                                                            : ''}
                                                                    </span>
                                                                ) : null}

                                                                {capitalGainItem && capitalGainItem.response ? (
                                                                    <span>
                                                                        <span onClick={() => handlePreviewModal(capitalGainItem.response)}>
                                                                            <Tooltip title="Preview">
                                                                                <img
                                                                                    src={PreviewImage}
                                                                                    alt="PreviewImage"
                                                                                    className="fileView"
                                                                                />
                                                                            </Tooltip>
                                                                        </span>
                                                                        <span onClick={() => downloadCoreFile(capitalGainItem.response)}>
                                                                            <Tooltip title="Download">
                                                                                <img
                                                                                    src={downloadImage}
                                                                                    alt="downloadImage"
                                                                                    className="downlaodImg downloadImgTop"
                                                                                />
                                                                            </Tooltip>
                                                                        </span>
                                                                    </span>
                                                                ) : null}
                                                                {/* </Grid> */}
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </Grid>
                                                <PreviewModal
                                                    fileSource={downloadFile}
                                                    visibleClose={visible}
                                                    handleModalClose={handleModalClose}
                                                />
                                                {
                                                    showBtnLoader ? (
                                                        <LoaderPopUp
                                                            showLoader={showBtnLoader}
                                                            // handleClose={handleClose}
                                                            title=""
                                                        />
                                                    ) : null
                                                }
                                            </FormControl>
                                        );
                                    })}
                                </Grid>
                            </span>
                        ) : null}
                    </Grid>
                );
            }}
        </Formik >
    );
};

export default CRCCapitalgain;
